import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchemaActivateMember = () => {
  const { t } = useTranslation();
  const requiredMessage = t('common:validationMessages.required');

  const invalidDateMessage = t('common:validationMessages.invalidDateFormat');

  const activateMemberSchema = yup.object().shape({
    admDate: yup.date().required(requiredMessage).typeError(invalidDateMessage),
    expireDate: yup.date().required(requiredMessage).typeError(invalidDateMessage), // Ensure default is undefined or an empty object
    payDate: yup.date().required(requiredMessage).typeError(invalidDateMessage), // Ensure default is undefined or an empty object
  });

  return activateMemberSchema;
};
